// export const API_URL = 'https://aniketrasal.online'
// export const API_URL = 'http://localhost:5000'
export const API_URL = "https://aerobic-gymnazien-kbtv.onrender.com"